import moment from 'moment';
import {
  SET_ACTIVE_COHORT,
  UPDATE_COHORTS,
  COHORT_ADD_ASSESSMENT_PRESET,
  COHORT_DELETE_ASSESSMENT_PRESET,
  UPDATE_COHORT_ASSESSMENT_SETTINGS,
  SAVE_COHORT_ASSESSMENT_SETTINGS_START,
  SAVE_COHORT_ASSESSMENT_SETTINGS_FAILURE,
  ASSESSMENT_STATUS_FETCH_START,
  ASSESSMENT_STATUS_FETCH_SUCCESS,
  ASSESSMENT_STATUS_REFRESH_START,
  ASSESSMENT_STATUS_REFRESH_SUCCESS,
  ASSESSMENT_STATUS_FETCH_FAILED,
  UPDATE_COHORT_ENROLMENT_CLOSE_DATE,
  UPDATE_COHORT_ENROLMENT_CLOSE_DATE_START,
  UPDATE_COHORT_ENROLMENT_CLOSE_DATE_FAILED,
  UPDATE_COHORT_ACCESS_TIME_TIMEZONE_START,
  UPDATE_COHORT_ACCESS_TIME_TIMEZONE_SUCCESS,
  UPDATE_COHORT_ACCESS_TIME_TIMEZONE_FAILED,
} from './actions';
import {
  COHORT_TIMELINE_UPDATE_START,
  COHORT_TIMELINE_UPDATE_FALED,
  UPDATE_COHORT_STARTDATE,
  UPDATE_COHORT_ENDDATE,
  SET_COHORT_SCHEDULED_MODE,
  SET_COHORT_OPEN_MODE,
  SET_COHORT_SELF_PACED_MODE,
  UPDATE_COHORT_SELF_PACED,
} from '../../web/containers/CohortAdmin/CohortTimeline/store';

import Resource, { ResourceApi } from '../../resource/Resource';
import { selectCurrentUtcoffset } from '../../web/containers/CohortAdmin/CohortTimeline/selectors';
import { currentCohortSelector } from './selectors';

export function setActiveCohort(cohort) {
  return (dispatch) =>
    dispatch({
      type: SET_ACTIVE_COHORT,
      cohort,
    });
}

export function updateCohorts(cohortList) {
  return (dispatch) =>
    dispatch({
      type: UPDATE_COHORTS,
      cohortList,
    });
}

export function retrieveCohort(cohortPath) {
  return (dispatch) => {
    Resource.lookup('cohort', 'resources', {
      initArgsList: cohortPath,
      ignoreMissing: true,
    }).then((cohorts) => {
      dispatch(updateCohorts(Object.values(cohorts)));
    });
  };
}

export function addCohortAssessmentPreset(cohortPath, preset) {
  return (dispatch) => {
    dispatch({
      type: COHORT_ADD_ASSESSMENT_PRESET,
      cohortPath,
      preset,
    });
    Resource.update('cohort', cohortPath, 'addAssessmentPreset', {
      mongo_id: preset._id,
      maximumMark: preset.maximumMark,
      bands: preset.bands,
      categories: preset.categories,
      name: preset.name,
      type: preset.type,
    });
  };
}

export function deleteCohortAssessmentPreset(cohortPath, presetId) {
  return (dispatch) => {
    dispatch({
      type: COHORT_DELETE_ASSESSMENT_PRESET,
      cohortPath,
      presetId,
    });
    Resource.update('cohort', cohortPath, 'deleteAssessmentPreset', {
      presetId,
    });
  };
}

export function updateAssessmentSettings(
  cohortPath,
  updatedAssessmentSettings
) {
  return (dispatch) => {
    dispatch({ type: SAVE_COHORT_ASSESSMENT_SETTINGS_START, cohortPath });
    return new Promise((resolve, reject) => {
      Resource.update('cohort', cohortPath, 'setAssessmentSettings', {
        assessmentSettings: updatedAssessmentSettings.toJS(),
      })
        .then((assessmentSettings) => {
          setTimeout(() => {
            dispatch({
              type: UPDATE_COHORT_ASSESSMENT_SETTINGS,
              cohortPath,
              assessmentSettings,
            });
            resolve();
          }, 300);
        })
        .fail(() => {
          setTimeout(() => {
            dispatch({
              type: SAVE_COHORT_ASSESSMENT_SETTINGS_FAILURE,
              cohortPath,
            });
            reject(new Error('Error saving assessment settings'));
          }, 300);
        });
    });
  };
}

export function getAssessmentStatus(coursePath, cohortPath, actionType) {
  const action = actionType || 'fetch';
  const getDispatchActionForStart = () => {
    switch (action) {
      case 'fetch':
        return ASSESSMENT_STATUS_FETCH_START;
      case 'refresh':
        return ASSESSMENT_STATUS_REFRESH_START;
      default:
        return null;
    }
  };

  const getDispatchActionForSuccess = () => {
    switch (action) {
      case 'fetch':
        return ASSESSMENT_STATUS_FETCH_SUCCESS;
      case 'refresh':
        return ASSESSMENT_STATUS_REFRESH_SUCCESS;
      default:
        return null;
    }
  };
  return (dispatch) => {
    dispatch({ type: getDispatchActionForStart() });
    Resource.read('cohort', cohortPath, 'getAssessmentStatus')
      .then((response) => {
        let assessmentNavigation = null;
        if (response.assessmentReportCohortMemberships[0]) {
          assessmentNavigation = {
            name: 'Assessment Reports',
            url: null,
            pagePath: null,
            external: false,
            type: 'navigation',
            icon: null,
          };
        }
        dispatch({
          type: getDispatchActionForSuccess(),
          coursePath,
          cohortPath,
          cohortMemberships: response.assessmentReportCohortMemberships,
          assessmentEvaluations: response.assessmentEvaluations,
          navigationItem: assessmentNavigation,
        });
      })
      .catch((error) => {
        dispatch({ type: ASSESSMENT_STATUS_FETCH_FAILED, error });
      });
  };
}

export function updateCohortClassAccessTimezone(cohortPath, tz) {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_COHORT_ACCESS_TIME_TIMEZONE_START,
    });

    try {
      await ResourceApi.update('cohort', cohortPath, 'setClassAccesTimezone', {
        tz,
      });
      dispatch({
        type: UPDATE_COHORT_ACCESS_TIME_TIMEZONE_SUCCESS,
        cohortPath,
        tz,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_COHORT_ACCESS_TIME_TIMEZONE_FAILED,
        error,
      });
    }
  };
}

export function updateAllModulePagesAccessStartDates(cohortPath) {
  return async () => {
    ResourceApi.update(
      'cohort',
      cohortPath,
      'updateAllModulePagesAccessStartDates',
      {}
    );
  };
}

export function updateCohortStartDate(cohortPath, startDate) {
  return async (dispatch, getState) => {
    const utcOffset = selectCurrentUtcoffset(getState());
    // NOTE: We receive startDate in moment object and startDate must be converted to UTC format (...T:12:00:00+10:00)
    const startDateUTC =
      startDate && moment(startDate).format(`YYYY-MM-DDTHH:mm:ss${utcOffset}`);

    dispatch({ type: COHORT_TIMELINE_UPDATE_START });
    let when;
    if (startDate && startDate !== '' && startDateUTC) {
      when = moment(startDateUTC).unix();
    } else {
      when = null;
    }

    dispatch({
      type: UPDATE_COHORT_STARTDATE,
      cohortPath,
      startDate: startDateUTC !== '' ? startDateUTC : null,
    });

    let setStartDateRsp;
    try {
      setStartDateRsp = await ResourceApi.update(
        'cohort',
        cohortPath,
        'setStartDate',
        {
          when,
        }
      );

      dispatch(updateAllModulePagesAccessStartDates(cohortPath));
    } catch (error) {
      setStartDateRsp = error;
      dispatch({
        type: COHORT_TIMELINE_UPDATE_FALED,
        errorMessage: {
          // hack: remove 'Error Invalid: ' from the error message
          startDate: error.message.replace('Error Invalid: ', ''),
        },
      });
    }

    return Promise.resolve(setStartDateRsp);
  };
}

export function updateCohortEndDate(cohortPath, endDate) {
  return async (dispatch, getState) => {
    const utcOffset = selectCurrentUtcoffset(getState());
    // NOTE: We receive endDate in moment object and endDate must be converted to UTC format (...T:12:00:00+10:00)
    const endDateUTC =
      endDate && moment(endDate).format(`YYYY-MM-DDTHH:mm:ss${utcOffset}`);
    dispatch({ type: COHORT_TIMELINE_UPDATE_START });
    let when;
    if (endDate && endDate !== '' && endDateUTC) {
      when = moment(endDateUTC).unix();
    } else {
      when = null;
    }

    dispatch({
      type: UPDATE_COHORT_ENDDATE,
      cohortPath,
      endDate:
        endDateUTC && endDateUTC !== '' ? moment(endDateUTC).format() : null,
    });

    let setEndDateRsp;

    try {
      setEndDateRsp = await ResourceApi.update(
        'cohort',
        cohortPath,
        'setEndDate',
        {
          when,
        }
      );
    } catch (error) {
      setEndDateRsp = error;
      dispatch({
        type: COHORT_TIMELINE_UPDATE_FALED,
        errorMessage: {
          endDate:
            error.response.error === 'Invalid'
              ? 'Some modules are available until after the course end date. Check your class schedule.'
              : error.message,
        },
      });
    }
    return Promise.resolve(setEndDateRsp);
  };
}

export function setCohortScheduledMode(cohortPath) {
  return (dispatch) => {
    dispatch({ type: COHORT_TIMELINE_UPDATE_START });
    return ResourceApi.update('cohort', cohortPath, 'setScheduled', {
      isScheduled: true,
    }).then(
      () =>
        dispatch({
          type: SET_COHORT_SCHEDULED_MODE,
          cohortPath,
        }),
      (error) =>
        dispatch({
          type: COHORT_TIMELINE_UPDATE_FALED,
          errorMessage: {
            pacingMode:
              error.response.error === 'Invalid'
                ? 'You must set a start date to use scheduled pacing.'
                : 'Error switching to the scheduled pacing.',
          },
        })
    );
  };
}

export function setCohortOpenMode(cohortPath) {
  return (dispatch) => {
    dispatch({ type: COHORT_TIMELINE_UPDATE_START });
    return ResourceApi.update('cohort', cohortPath, 'setOpen').then(
      () =>
        dispatch({
          type: SET_COHORT_OPEN_MODE,
          cohortPath,
        }),
      (error) =>
        dispatch({
          type: COHORT_TIMELINE_UPDATE_FALED,
          errorMessage: {
            pacingMode: error.message,
          },
        })
    );
  };
}

export function setCohortSelfPacedMode(cohortPath) {
  return (dispatch) => {
    dispatch({ type: COHORT_TIMELINE_UPDATE_START });
    return ResourceApi.update('cohort', cohortPath, [
      { method: 'setScheduled', args: { isScheduled: false } },
      { method: 'setSelfPaced', args: { isSelfPaced: true } },
    ]).then(
      () =>
        dispatch({
          type: SET_COHORT_SELF_PACED_MODE,
          cohortPath,
        }),
      (error) =>
        dispatch({
          type: COHORT_TIMELINE_UPDATE_FALED,
          errorMessage: { pacingMode: error.message },
        })
    );
  };
}

export function setCohortSelfPaced(cohortPath, isSelfPaced) {
  return (dispatch) => {
    dispatch({ type: COHORT_TIMELINE_UPDATE_START });
    return ResourceApi.update('cohort', cohortPath, 'setSelfPaced', {
      isSelfPaced,
    }).then(() =>
      dispatch({
        type: UPDATE_COHORT_SELF_PACED,
        cohortPath,
        isSelfPaced,
      })
    );
  };
}

export function updateCohortEnrolmentCloseDate(cohortPath, enrolmentCloseDate) {
  return async (dispatch, getState) => {
    const utcOffset = selectCurrentUtcoffset(getState());
    // NOTE: We receive endDate in moment object and endDate must be converted to UTC format (...T:12:00:00+10:00)
    const enrolmentCloseDateUTC =
      enrolmentCloseDate &&
      moment(enrolmentCloseDate).format(`YYYY-MM-DDTHH:mm:ss${utcOffset}`);
    const when =
      enrolmentCloseDateUTC && enrolmentCloseDateUTC !== ''
        ? moment(enrolmentCloseDateUTC).unix()
        : null;

    dispatch({ type: UPDATE_COHORT_ENROLMENT_CLOSE_DATE_START });
    dispatch({
      type: UPDATE_COHORT_ENROLMENT_CLOSE_DATE,
      cohortPath,
      enrolmentCloseDate:
        enrolmentCloseDateUTC && enrolmentCloseDateUTC !== ''
          ? moment(enrolmentCloseDateUTC).format()
          : null,
    });

    let setEnrolmentCloseDateRsp;

    try {
      setEnrolmentCloseDateRsp = await ResourceApi.update(
        'cohort',
        cohortPath,
        'setEnrolmentCloseDate',
        {
          enrolmentCloseDate: when,
        }
      );
    } catch (error) {
      setEnrolmentCloseDateRsp = error;
      dispatch({
        type: UPDATE_COHORT_ENROLMENT_CLOSE_DATE_FAILED,
        errorMessage: {
          enrolmentCloseDate: error.message,
        },
      });
    }

    return Promise.resolve(setEnrolmentCloseDateRsp);
  };
}

export function fetchUserActiveCohort(coursePath) {
  return (dispatch) => {
    return Resource.lookup('cohort', 'getUserActiveCohort', {
      coursePath,
    }).then((cohort) => {
      dispatch(updateCohorts([cohort]));
    });
  };
}

export function getInstitutionSpecificSettings() {
  return async (_, getState) => {
    const cohort = currentCohortSelector(getState());
    return ResourceApi.read(
      'cohort',
      cohort.get('path'),
      'getInstitutionSpecificSettings'
    );
  };
}

export function updateInstitutionSpecificPrice({
  institutionPath,
  enabled,
  basePrice,
  otherStudentPrices,
}) {
  return async (_, getState) => {
    const cohort = currentCohortSelector(getState());
    return ResourceApi.update(
      'cohort',
      cohort.get('path'),
      'updateInstitutionSpecificPrice',
      {
        institutionPath,
        enabled,
        basePrice,
        otherStudentPrices,
      }
    );
  };
}
